<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Perumahan : Bayaran Potongan Gaji">
            <w-form
                class=""
                v-model="form.valid"
                v-model:errors-count="form.errorsCount"
                @validate="simpan"
                @success="Success"
            >
                <div class="message-box">
                    <w-transition-fade>
                        <w-alert
                            class="my0 text-light"
                            v-if="form.submitted"
                            success
                            no-border
                        >
                            The form is valid, ready to send it!
                        </w-alert>

                        <w-alert
                            class="my0 text-light"
                            v-else-if="form.valid === false"
                            error
                            no-border
                        >
                            Terdapat {{ form.errorsCount }} ralat di dalam
                            borang ini.
                        </w-alert>
                    </w-transition-fade>
                </div>


                <w-card bg-color="" class="">
                <w-flex justify-center align-center>
                    <div class="xs4">
                        <h5 class="fw-semibold m0">Agensi </h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.pejabat }}
                        </div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">Kod Jabatan</h5>
                        <div class="fw-normal my1 fs-1">{{ form.kod }}</div>
                    </div>

                    <div class="xs4">
                      <h5 class="fw-semibold m0">Nama Jabatan</h5>
                        <div class="fw-normal my1 fs-1">
                            {{form.nama}}
                        </div>
                    </div>
                </w-flex>

                <w-flex justify-center align-center>
                  <div class="xs4">
                        <h5 class="fw-semibold m0">No Telefon</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.no_tel}}
                        </div>
                    </div>
                    

                    <div class="xs4">
                       <h5 class="fw-semibold m0">Emel</h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.emel }}
                        </div>
                    </div>

                    <div class="xs4">
                        <h5 class="fw-semibold m0">
                            Alamat
                        </h5>
                        <div class="fw-normal my1 fs-1">
                            {{ form.lkp_poskod}},{{ form.lkp_bandar}}, {{ form.lkp_negeri}}
                        </div>
                    </div>
                </w-flex><br>
                    </w-card
                ><br />

                <!-- </w-from> -->
                <w-card bg-color="" class="">
                <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">
                <template #item-content.1>
                    <w-flex justify-center align-center>
                        <div class="w-card__content content-hardcode">
                            <table class="table-dashboard" width="100%">
                                <thead>
                                    <tr>
                                        <td>No</td>
                                        <td>Nama Pemotong Gaji</td>
                                        <td>Nama Pemilik Rumah</td>
                                        <td>No. Akaun</td>
                                        <td>Skim Perumahan</td>
                                        <td>Jenis Skim</td>
                                        <td>Kadar Angsuran Bulanan (RM)</td>
                                        <td>Jumlah Patut Kutip (RM)</td>
                                        <td>Kadar Potongan Gaji (RM)</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(dt, index) in form.perum_array">
                                        <td>{{index + 1}}</td>
                                         <td>
                                            <template v-if="dt.pembayar != ''">
                                                <template v-for="(d, index) in dt.pembayar">
                                                    {{d.nama_id}}
                                                </template>
                                            </template>
                                            <template v-else>
                                                {{dt.no_id}} | {{dt.nama_profil}}
                                            </template>
                                        </td>
                                        <td>{{dt.no_id}} | {{dt.nama_profil}}</td>
                                        <td>{{dt.no_akaun}}</td>
                                        <td>{{dt.no_skim}}</td>
                                        <td>{{dt.lkp_perumahan}}</td>
                                        <td>{{$zutil.currency(dt.jumlah_amaun_bil)}}</td>
                                        <td>{{$zutil.currency(dt.amaun_patut_kutip)}}</td>
                                        <td>{{$zutil.currency(dt.amaun_potongan)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </w-flex>
				<w-form
		            class=""
		            v-model="form.valid"
		            v-model:errors-count="form.errorsCount"
		            @validate="submitResit"
		            @success="onSuccess"
		        >
                <w-flex justify-center align-center class="mt5">
                    <div class="w-card__content content-hardcode">
                        <table class="table-dashboard" width="100%">
                            <thead>
                                <tr>
                                    <td>Cara Bayaran</td>
                                    <td>TARIKH EFT</td>
                                    <td>Bank</td>
                                    <td>No Cek / Bank Draf / Transaksi Bank</td>
                                    <td>TARIKH CEK / BANK DRAF</td>
                                    <td>Amaun (RM)</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(d, index) in cara_bayaran_perumahan">
                                    <td>
                                        <z-lookup 
                                        	:url="service_utiliti + 'lookup/cara_bayar_pendidikan'"
                                            :sort="false"
                                            :cache="false"
                                            v-model="d.lkp_cara_bayaran_id"
                                            required
                                            :validators="[validators.required]"
                                        />
                                    </td>
                                    <td>
                                        <template v-if="d.lkp_cara_bayaran_id == 32" >
                                               <z-input 
                                                  name="tarikh_eft" 
                                                  v-model="d.tarikh_eft" 
                                                  type="date"  :validators="[
                                                        validators.required,
                                                    ]"/>
                                        </template>
                                    </td>
                                    <td>
                                        <!-- <template v-for="(a, index) in cara_bayar11">
                                        <template v-if="d.lkp_cara_bayaran_id == a.id && a.is_bank  == 1" > -->
                                            <z-lookup
                                                :url=" service_utiliti + 'lookup/bank' "
                                                :sort="false"
                                                :cache="false"
                                                v-model="d.lkp_bank_id"
                                                :validators="[ validators.required]"
                                            />
                                        <!-- </template>
                                        </template> -->
                                    </td>
                                    <td>
                                        <!-- <template v-for="(b, index) in cara_bayar11">
                                        <template v-if="d.lkp_cara_bayaran_id == b.id && b.is_dokumen  == 1" > -->
                                            <w-input
                                                class="mb4"
                                                v-model="d.no_dokumen"
                                            	@keyup ="cekJumlah(d)"
                                                :validators="[validators.required]"
                                            />
                                        <!-- </template>
                                        </template> -->
                                    </td>
                                    <td>
                                        <template v-for="(c, index) in cara_bayar">
                                            <template v-if="d.lkp_cara_bayaran_id == c.id && c.is_cek  == 1" >
                                               <z-input 
                                                  name="tarikh_cek" 
                                                  v-model="d.tarikh_cek" 
                                                  type="date"  :validators="[
                                                        validators.required,
                                                    ]"/>
                                            </template>
                                        </template>
                                    </td>
                                    <td align="right">
                                        {{ $zutil.currency(amaun_jumlah) }}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="5" align="right">
                                        Jumlah (RM)
                                    </td>
                                    <td align="right">
                                        <b>{{ $zutil.currency( amaun_jumlah ) }}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="5" align="right">
                                        Jumlah Perlu Dibayar(RM)
                                    </td>
                                    <td align="right">
                                        <b>{{$zutil.currency(amaun_jumlah)}}
                                        </b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </w-flex>

		            <w-flex class="mt6" wrap align-center justify-end>
	                    &nbsp;&nbsp;&nbsp;   
			                <w-button
		                        class="my1"
		                        bg-color="warning"
		                        @click="back()"
		                        >Kembali</w-button
		                    >
		                    &nbsp;&nbsp;&nbsp;   
		                    <w-button
		                        class="mr2"
		                        bg-color="warning"
		                        type="reset"
		                        @click="clear()"
		                    >
		                        Reset
		                    </w-button>
		                    &nbsp;&nbsp;&nbsp;  
		                    <w-button
		                        class="my1"
		                        type="submit"
		                        :disabled="form.valid === false"
		                        :loading="form.submitted && !form.sent"
		                    >
		                        <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon>
		                        Hantar
		                    </w-button>
		            </w-flex>
		        </w-form>
                </template>
                <template #item-content.2>
                    <w-flex justify-center align-center>
                            <div class="w-card__content content-hardcode">
                                <table class="table-dashboard" width="100%">
                                    <thead>
                                        <tr>
                                            <td width="2%">No</td>
                                            <td width="15%">Tarikh</td>
                                            <td>Pengguna</td>
                                            <td>Status</td>
                                            <td>Catatan</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(dt, index ) in form.jejak_audit_pejabat" >
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ dt.tarikh }}</td>
                                            <td>{{ dt.user_nama }}</td>
                                            <td>
                                                {{ dt.tindakan_keterangan_perumahan_pejabat }}
                                            </td>
                                            <td>{{ dt.catatan }}</td>
                                        </tr>
                                        <tr v-if="form.jejak_audit.length == 0">
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </w-flex>
                </template>
                </w-tabs>
                </w-card>
            </w-form>
            
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {},
    props: {
        id: [Array, Object, String],
    },
    data() {
        return {
            isHidden: false,
            resourceurl: this.service_tunggakan + "perumahan_agensi/agensi/bayaran",
            reload: true,
            perumahan: [],
            cara_bayaran_perumahan : [],
            amaun_butiran: 0,
            amaun_bayaran: 0,
            amaun_jumlah: 0,
            dialogProfil: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 800,
                form: { nama: "", email: "" },
            },
            form : {
              loading: false,
            },
            loading: false,
            selection: true,
            id : null,
            tabs: [
                { title: "Butiran Bayaran", content: "" },
                { title: "Jejak Audit", content: "" },
            ],
            activeTab : 0,
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Perumahan", route: "/perumahan" },
                { label: "Agensi Pembayar", route: "/perumahan/agensi" },
                { label: "Bayar Potongan Gaji", route: "/deposit/" + this.id },
            ],
            validators: {
                required: (value) => !!value || "Medan ini wajib diisi",
                consent: (value) => !!value || "You must agree",
                email: (value) =>
                    !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
                    "Sila Semak Format Email",
                numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
            },
        };
    },
    methods: {


        submitResit() {
            // if (this.$refs.form.validate()) {
            if (this.form.valid == true) {
                this.form.valid = false
                this.form.cara_bayaran_perumahan = this.cara_bayaran_perumahan;
                this.form.amaun_jumlah = this.amaun_jumlah;
                this.$zcomm
                    .post(this.resourceurl+'/simpan/'+ this.form.id, this.form)
                    .then((res) => {
                        if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd();
                        }

                        this.$zutil.notify("Rekod telah berjaya dihantar");
                        this.$inertia.visit(
                            this.$route("kutipan.resit.index") +
                                "?resit_id=" +
                                res
                        );
                    })
                    .catch((err) => {})
                    .finally(() => {});
            }
        },
        caraBayarPerumahan() {
	        this.$zcomm
	            .post(this.service_utiliti + "lookup/cara_bayar",{})
	            .then((res) => {
        			this.cekJumlah();
	                this.cara_bayar11 = res
	            });

        },
        
        cekJumlah(){
	      	this.amaun_jumlah = 0;
	    	for (var i in this.form.perum_array) {
	        // this.amaun_jumlah = this.amaun_jumlah + parseFloat(this.form.perum_array[i].jumlah_amaun_bil);
            this.amaun_jumlah = this.amaun_jumlah + parseFloat(this.form.perum_array[i].amaun_potongan);
	    	}
	    },
	    back(){
               this.$inertia.visit(this.$route('perumahan-agensi.agensi.show', this.form.id));
	    },
	    clear () {
        	this.getData();
          	this.files = false
          	this.$nextTick(() => {
            	this.files = true
          	})
        },

        getData()  {
          var app = this;

          if(this.id){
            if(this.id > 0){
              this.$zcomm.get(this.service_tunggakan +'perumahan_agensi/agensi/bayaran/'+this.id+''+window.location.search).then(res => {
                this.form = res;

              })
              .finally(() => {

                this.loading = false
                this.cekJumlah();
              });
            }
          }
          
          
        },

    },
    watch: {
    	"perum_array": function () {
        	this.cekJumlah();
        },
    },
    mounted() {
        // this.dialog.width = 900;
        this.cekJumlah();
        this.caraBayarPerumahan();
        this.getData();
        this.cara_bayaran_perumahan = [
            {
                lkp_cara_bayaran_id: null,
                lkp_bank_id: null,
                no_dokumen: null,
                amaun_jumlah: null,
                tarikh_eft: null,
            },
        ];
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
